import { useTranslation } from 'react-i18next';
import { Save } from 'lucide-react';
import { TranslatedCalling } from './common';

function RememberForUserResult() {
  const { t } = useTranslation('chat');
  return (
    <div className="text-xs text-gray-400 font-light flex items-center gap-1">
      <Save className="w-3 h-3" />
      {t('tool.remember-for-user.updated-memory')}
    </div>
  );
}

export const remember_for_user = {
  type: 'thinking',
  call: () => <TranslatedCalling i18nKey="tool.common.thinking" />,
  'partial-call': () => <TranslatedCalling i18nKey="tool.common.thinking" />,
  result: () => <RememberForUserResult />,
};
